import { cn } from '@/lib/utils';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ButtonStroke({ url, icon, text, className, onClick }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) onClick(e);
    else if (url) navigate(url);
  };

  return (
    <div>
      <button
        onClick={handleClick}
        className={cn(
          "flex h-[3.5rem] w-fit items-center gap-2 px-4 py-2 text-prime-700 border border-prime-500 font-sans rounded-md hover:bg-prime-700 hover:text-white transition-all",
          className
        )}
      >
        <div className='flex items-center justify-start w-full gap-2'>
          <div className='w-[3rem] self-start'>{icon}</div>
          <div className='w-full'>{text}</div>
        </div>
      </button>
    </div>
  );
}
